import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sickpay-plus',
  templateUrl: './sickpay-plus.component.html',
  styleUrls: ['./sickpay-plus.component.scss']
})
export class SickpayPlusComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
